import {
    Base,
    PricesRequest,
    PricesResponse,
    ProductDescriptionUpdateRequest,
    ProductRequest,
    ProductsImportGetResponse,
    ProductsImportResponse,
    ProductsQuery,
    ProductsResponseType,
    ProductsSearchResponse,
    Response,
} from '@.api/methods';
import { ProductResource } from '@/entities/Product/api/ProductResource';
import { Request } from '@/Types';

export class Products extends Base {
    public getAll(query?: ProductsQuery) {
        this.setPath('products');
        if (query) this.setQuery(query);

        return this.getRequest() as Response<ProductsResponseType>;
    }

    public getById(id: number) {
        this.setPath('products');
        this.setId(id);

        return this.getRequest() as Response<ProductResource>;
    }

    public create(data: ProductRequest): Response<ProductResource> {
        this.setPath('products');
        this.setData(data);

        return this.postRequest<ProductResource>();
    }

    public update(data: ProductRequest, id: number): Response<ProductResource> {
        this.setPath('products');
        this.setId(id);
        this.setData(data);

        return this.putRequest<ProductResource>();
    }

    public descriptionUpdate(id: number | string, data: ProductDescriptionUpdateRequest) {
        this.setPath(`products/${id}/descriptions`);
        this.setData(data);

        return this.putRequest();
    }

    public archive(id: number) {
        this.setPath('products');
        this.setId(id);

        return this.deleteRequest<ProductResource>();
    }

    public restore(id: number) {
        this.setPath('products');
        this.setId(`${id}/restore`);

        return this.postRequest<ProductResource>();
    }

    public getPrices(id: number) {
        this.setPath('products');
        this.setId(`${id}/prices`);

        return this.getRequest() as Response<PricesResponse>;
    }

    public postPrices(data: PricesRequest, id: number) {
        this.setPath('products');
        this.setId(`${id}/prices`);
        this.setData(data);

        return this.postRequest<PricesResponse>();
    }

    public import(data: { products_ids: number[] }) {
        this.setPath('products/import');
        this.setData(data);

        return this.postRequest() as Response<ProductsImportResponse>;
    }

    public importGet(query?: Request.All) {
        this.setPath('products/import');
        query && this.setQuery(query);

        return this.getRequest<ProductsImportGetResponse>();
    }

    public search(query: { search: string }) {
        this.setPath('products/search');
        this.setQuery(query);

        return this.getRequest() as Response<ProductsSearchResponse>;
    }
}
